import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installImageErrorFallback } from "./lib/imageFallback";

// Listener globale: intercetta gli errori di caricamento delle <img> e
// sostituisce la sorgente con un segnaposto same-origin (vedi imageFallback.ts).
// Va installato PRIMA del render così copre anche le prime immagini paintate.
installImageErrorFallback();

createRoot(document.getElementById("root")!).render(<App />);
